export default "__VITE_ASSET__B6aXEI_u__"